import SignUpForm from '../components/SignUpForm';

function SignUpPage() {
	return (
		<div className="container">
			<div className="row justify-content-center">
				<div className="col-md-6">
					<section>
						<SignUpForm />
					</section>
				</div>
			</div>
		</div>
	);
}

export default SignUpPage;
